import '../../styles/sass/main.scss';
import './header';
import './hero';
import { initFitText } from './fit-text';
import { initGalleryLightbox } from './gallery';

document.addEventListener('DOMContentLoaded', () => {
  console.log('DOM fully loaded and parsed');
  initFitText();
  initGalleryLightbox();
  // Wrap 'Protected: ' in a span for styling
  document.querySelectorAll<HTMLElement>('.wp-block-post-title').forEach(el => {
    if (el.textContent && el.textContent.trim().startsWith('Protected: ')) {
      // Only wrap if not already wrapped
      if (!el.innerHTML.startsWith('<span class="protected-prefix"')) {
        el.innerHTML = el.innerHTML.replace(
          /^Protected: /,
          '<span class="protected-prefix">Protected: </span>'
        );
      }
    }
  });
});
